import {utils,write} from "xlsx";
import { saveAs } from "file-saver";
import { toast } from 'react-toastify';

export async function downloadCouponReports(promo,check=false){
        
        const sheetName=promo.PromoGroupName
        const data=promo.children
        try {

            const workbook = utils.book_new();
            const sheetData = [];

            sheetData.push(["Promo Codes"])
            if(check){
                data.forEach(element => {
                    sheetData.push([element])
                });
            }else{
                data.forEach(element => {
                    sheetData.push([element.Code])
                });
            }
            

            

            const worksheet = utils.aoa_to_sheet(sheetData,{ cellStyles: true });
            utils.book_append_sheet(workbook, worksheet, `${sheetName}`);
            const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });
            const excelData = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(excelData, `${sheetName}.xlsx`);
            
            
        } catch (error) {
            
            toast.error("Error While Exporting Promo Codes",{
                bodyClassName:"notification-div-error",
                progressClassName:"progress-bar-error"
            })
        }
}